const AVITO_LENGTH_RE =
  /AvitoFormatter:\s*(?<field>Title|Description)\s*length=(?<actual>\d+)\s*>\s*max=(?<max>\d+)\s*\(policy="fail"\)/i;

/** Превращает технические причины фейлов экспорта в человекочитаемый текст; неизвестные сообщения возвращаются как есть. */
export const humanizeFailedReason = (raw?: string): string | undefined => {
  if (!raw) return undefined;
  const groups = raw.match(AVITO_LENGTH_RE)?.groups;
  if (!groups) return raw;

  const field =
    groups.field.toLowerCase() === "title" ? "название" : "описание";
  return `Экспорт остановлен: у товара слишком длинное ${field} (${groups.actual} символов, максимум ${groups.max}). Поменяйте политику на «Обрезать» или «Пропускать товар» в настройках Avito.`;
};
